export const FOCUS_EVENT: string = 'focusin';
export const BLUR_EVENT: string = 'focusout';
